import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: sans-serif;
  }
  
  ul {
    list-style-type: none;
  }
  
  button {
    background: none;
    border: none;
  }
  
  a {
    text-decoration: none;
  }
  
  button, a {
    cursor: pointer;
    outline: none;
  }
  
  body {
    background: #e7e7e7;
  }

  .MuiTooltip-popper {
    white-space: pre-line !important;
  }
`;

export default GlobalStyles;
